import React from "react";
import Avatar from "../../assets/image/avatar.jpg";
import moment from "moment";
import { Link } from "react-router-dom";

import { PRIORITY } from "./../config/const";
import AvatarCompany from "../../assets/image/company.png";
import Dots_nav_icon from "../../assets/image/dots-horizontal-icon.svg";
import { modelMap } from "../config/config";
import { MOVEMENTS, WEEK } from "../config/const";
import { MERCHANDISER_MAIN_PAGE, VISIT_PAGE } from "../config/lang";

import { call } from "../util/action";
import { getStore } from "../util/redux/store";
import { translate, translateDynamic } from "../util/util";

const me = getStore().getState().me;
export function IDFormatter(value) {
  return value;
}

export function IDFormatter2() {
  return "";
}

// TABLES
export function openVisit(id) {
  return (
    <a href={`/visit/${id}`} className="btn btn-sm btn-outline-primary" target="_blank">
      <i className="fa fa-external-link can_open" /> {translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)}
    </a>
  );
}
export function openVisitRow(id, history) {
  history.push(`/visit/${id}`);
}

export function openSingleVisitTaskRow(id, history) {
  // history.push(`/task/${id}`);
  const url = `/task/${id}`;
  window.open(url, "_blank");
}

export function openTask(id) {
  return (
    <a href={`/task/${id}`} className="btn btn-sm btn-outline-primary" target="_blank">
      <i className="fa fa-external-link can_open" />
    </a>
  );
}

export function openRoute(id) {
  return (
    <a href={`/route/${id}`} className="btn btn-sm btn-outline-primary">
      <i className="fa fa-external-link can_open" /> {translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)}
    </a>
  );
}

export function openMerchandiser(id) {
  return (
    <a href={`/merchandiser/${id}`} className="btn btn-sm btn-outline-primary">
      <i className="fa fa-external-link can_open" /> {translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)}
    </a>
  );
}

export function openPoint(id) {
  return (
    <a href={`/point/${id}`} className="btn btn-sm btn-outline-primary">
      <i className="fa fa-external-link can_open" /> {translate(MERCHANDISER_MAIN_PAGE, "view_btn", me.language)}
    </a>
  );
}

export function points(i, item) {
  return (
    <div>
      {(item.points || []).map((i, idx) => (
        <div key={(i.point?.name || "") + idx}>{i.point?.name}</div>
      ))}
    </div>
  );
}

export function pointsCount(i, item) {
  return item.points?.length || 0;
}

export function point(i, item) {
  return item.point ? item.point.name + " - " + item.point.address : "";
}

export function visitPoint(i, item, cb) {
  if (!item.point) return;
  let date = "";

  if (item.start) {
    let newDate = new Date(item.start);
    date = moment(newDate).format("DD/MM/yyyy");
  }

  const author = `${item.user?.first_name || ""} ${item.user?.last_name || ""}`.trim();

  return (
    <a
      href={`/visit/${item.id}`}
      onClick={() => {
        if (cb) cb(i);
      }}>
      <strong>{`${item.point.locality?.name || ""} - ${item.point.name} - ${item.point.address} - ${date}`}</strong>
      <p className="added-by">{translateDynamic(item.start, VISIT_PAGE, me.language, author)}</p>
    </a>
  );
}

export function visitOnePoint(i, item) {
  if (!item.point) return;
  let date = "";

  if (item.start) {
    let newDate = new Date(item.start);
    date = moment(newDate).format("DD.MM.yyyy HH:mm");
  }

  const author = `${item.user?.first_name || ""} ${item.user?.last_name || ""}`.trim();
  const visitFullName = `${item.point.locality?.name || ""} - ${item.point.name} - ${item.point.address}`;
  const visitDate = date;

  return { name: visitFullName, date: visitDate, author: author };
}

export function visitItemStatus(i, item) {
  if (!item.collect_status_reports) return;

  const values = [
    item.collect_status_reports.completed_reports >= 0 ? item.collect_status_reports.completed_reports : 0,
    item.collect_status_reports.on_review_reports >= 0 ? item.collect_status_reports.on_review_reports : 0,
    item.collect_status_reports.not_completed_reports >= 0 ? item.collect_status_reports.not_completed_reports : 0,
  ];
  const total = values.reduce((sum, value) => sum + value, 0);

  return (
    <div className={`vt-status-bar ${total === 0 ? "vt-status-bar--empty" : ""}`}>
      {values.map((value, index) => {
        const percentage = total > 0 ? (value / total) * 100 : 0;
        const cls = index === 0 ? "vt-seg--approved" : index === 1 ? "vt-seg--pending" : "vt-seg--rejected";
        const label =
          index === 0
            ? translate(VISIT_PAGE, "approved_label_popup", me.language)
            : index === 1
            ? translate(VISIT_PAGE, "pending_label_popup", me.language)
            : translate(VISIT_PAGE, "rejected_label_popup", me.language);
        return (
          <div
            key={index}
            className={`vt-seg ${cls}`}
            style={{ width: `${percentage}%`, display: percentage === 0 ? "none" : "flex" }}
            title={`${label}: ${value}`}>
            {value}
          </div>
        );
      })}
    </div>
  );
}

export function visitItemProgress(i, item) {
  if (!item.collect_status_reports?.progress_reports) return;
  return <div className="vt-progress">{item.collect_status_reports.progress_reports}</div>;
}

export function visitItemAction(i, item, cb) {
  if (!item.id) return;

  return (
    <div className="vt-action-menu">
      <button className="vt-action-trigger">
        <span className="material-symbols-outlined">more_horiz</span>
      </button>
      <div className="vt-action-dropdown">
        <button className="vt-action-option vt-action-option--approve" onClick={() => cb(item, "approve")}>
          <span className="material-symbols-outlined">check_circle</span>
          Approve
        </button>
        <button className="vt-action-option vt-action-option--reject" onClick={() => cb(item, "reject")}>
          <span className="material-symbols-outlined">cancel</span>
          Reject
        </button>
      </div>
    </div>
  );
}

export function visitItemMonitoringAction(i, item, cb) {
  return (
    <div className="visit-item-action">
      <img src={Dots_nav_icon} alt="visit action nav" className="visit-action-icon" />
      <ul className="visit-action-nav">
        <li
          onClick={() => {
            cb(item, "ACCEPT");
          }}>
          Approve
        </li>
        <li
          onClick={() => {
            cb(item, "REJECT");
          }}>
          Reject
        </li>
      </ul>
    </div>
  );
}

export function approveVisitStatus(i, item) {
  const className = item.is_approved ? "vt-dot vt-dot--approved" : item.is_approved === false ? "vt-dot vt-dot--rejected" : "vt-dot vt-dot--pending";
  return <span className={className}></span>;
}

export function taskTags(i, item) {
  return (
    <div>
      {item?.tags?.map((i, idx) => (
        <span key={i.name + idx} className="label rounded primary">
          {i.name}
        </span>
      ))}
    </div>
  );
}

export function taskComponents(i, item) {
  return (
    <span>
      {item.components &&
        item.components.map((i, idx) => (
          <span key={i.name + idx} className="label rounded primary">
            {i.name}
          </span>
        ))}
    </span>
  );
}

export function taskNegative(i, item) {
  return <span>{item.negative_answers_count}</span>;
}

export function taskComment(i, item) {
  return <span>{item.last_answer && item.last_answer.answer}</span>;
}

export function taskStatus(i, item) {
  const statusClass = item.status?.replace(/\s+/g, "-").toLowerCase() || "";
  return <span className={`tbl-status-chip tbl-status-chip--${statusClass}`}>{item.status}</span>;
}

export function pointsTask(i, item) {
  return (
    <div>
      {item?.tags?.map((i, idx) => (
        <span key={i.name + idx} className="label rounded primary">
          {i.name}
        </span>
      ))}
    </div>
  );
}

export function locality(i, item) {
  return <span>{item.locality && item.locality.name && item.locality.name}</span>;
}

export function pointState(i, item) {
  return (
    <span className={`tbl-status-chip ${item.is_active ? "tbl-status-chip--completed" : "tbl-status-chip--cancelled"}`}>
      {item.is_active ? "Active" : "Not Active"}
    </span>
  );
}

export function imageCount(i, item) {
  return item && item.image_count;
}

export function tagCount(i, item) {
  return item?.tags?.length;
}

export function day(i, item) {
  return <span className="dayLabel"> {item && WEEK[item.day_of_the_week]}</span>;
}

export function movement(i, item) {
  return <span> {item && MOVEMENTS[item.movement]}</span>;
}

export function userName(i, item) {
  return (
    <span className="merch-user-cell">
      {item.photo ? (
        <img
          className="merch-avatar"
          src={item.photo}
          onError={e => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      ) : null}
      <span className="merch-avatar-fallback" style={item.photo ? { display: "none" } : {}}>
        <span className="material-symbols-outlined">person</span>
      </span>
      <span className="merch-user-name">
        {item && item.first_name} {item && item.last_name}
      </span>
    </span>
  );
}

export function userState(i, item) {
  return (
    <span className={`merch-status-chip ${item.is_active ? "merch-status-chip--active" : "merch-status-chip--inactive"}`}>
      {item.is_active ? "Active" : "Not Active"}
    </span>
  );
}

export function supervisorName(i, item, cb) {
  if (item.point && item.point.responsible_supervisors?.length) {
    let user = item.point.responsible_supervisors[0];
    return (
      <span className="tbl-user-cell">
        {user.photo ? (
          <img
            className="tbl-user-avatar"
            src={user.photo}
            onError={e => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}
        <span className="tbl-user-avatar-fallback" style={user.photo ? { display: "none" } : {}}>
          <span className="material-symbols-outlined">person</span>
        </span>
        <span className="tbl-user-name">
          {user.first_name} {user.last_name}
        </span>
      </span>
    );
  }
}
export function createdByInfo(i, item) {
  const user = item.created_by;
  if (user) {
    return (
      <span className="tbl-user-cell">
        {user.photo ? (
          <img
            className="tbl-user-avatar"
            src={user.photo}
            onError={e => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}
        <span className="tbl-user-avatar-fallback" style={user.photo ? { display: "none" } : {}}>
          <span className="material-symbols-outlined">person</span>
        </span>
        <span className="tbl-user-name">
          {user.first_name} {user.last_name}
        </span>
      </span>
    );
  }
}

export function merchandiserName(i, item) {
  const user = item.point?.responsible_merchandiser;
  if (user) {
    return (
      <span className="tbl-user-cell">
        {user.photo ? (
          <img
            className="tbl-user-avatar"
            src={user.photo}
            onError={e => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}
        <span className="tbl-user-avatar-fallback" style={user.photo ? { display: "none" } : {}}>
          <span className="material-symbols-outlined">person</span>
        </span>
        <span className="tbl-user-name">
          {user.first_name} {user.last_name}
        </span>
      </span>
    );
  }
}

export function authorWay(i, item, cb) {
  if (!item.user) return;

  return (
    <a
      href={`/visit/${item.id}`}
      onClick={() => {
        if (cb) cb(item.id);
      }}>
      {item.user.first_name + " " + item.user.last_name}
    </a>
  );
}

export function merchandiserPhone(i, item) {
  if (item.point && item.point.responsible_merchandiser) {
    let user = item.point.responsible_merchandiser;
    return <span>{user.phone_number} </span>;
  }
}

export function networkName(i, item) {
  if (!item.network) return null;
  return (
    <span className="tbl-user-cell">
      {item.network.image ? (
        <img
          className="tbl-user-avatar"
          src={item.network.image}
          onError={e => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      ) : null}
      <span className="tbl-user-avatar-fallback" style={item.network.image ? { display: "none" } : {}}>
        <span className="material-symbols-outlined">store</span>
      </span>
      <span className="tbl-user-name">{item.network.name}</span>
    </span>
  );
}

export function networkTask(i, item) {
  return item.network && item.network.name && item.network.name;
}

export function getNetworkData(id) {
  let networkName = "";
  call({ method: "GET", url: modelMap["network"] }, response => {
    networkName = response?.find(item => item.id === id)?.name;
  });

  return networkName || "—";
}

// DATES
export function userDateJoined(i, item) {
  if (!item.date_joined) return;
  let date = new Date(item.date_joined);
  return moment(date).format("DD/MM/yyyy");
}

export function userDateTillNewbie(i, item) {
  if (!item.date_till_newbie) return;
  let date = new Date(item.date_till_newbie);
  return moment(date).format("DD/MM/yyyy");
}

export function userDateDeactivated(i, item) {
  if (!item.date_deactivated) return;
  let date = new Date(item.date_deactivated);
  return moment(date).format("DD/MM/yyyy");
}

export function timeSpent(i, item) {
  if (!item.time_spent) return;

  const seconds = item.time_spent;
  let minutes = Math.floor(seconds / 60);
  let remainingSeconds = Math.floor(seconds % 60);

  return (
    <div className="vt-time">
      <span className="material-symbols-outlined">schedule</span>
      {minutes}m {remainingSeconds}s
    </div>
  );
}

export function timeSpentSingleVisit(item) {
  if (!item?.time_spent) return;

  const seconds = item.time_spent;
  let minutes = Math.floor(seconds / 60);
  if (minutes > 60) {
    minutes = Math.floor(minutes / 60);
    return `${minutes}h`;
  } else {
    return `${minutes}m`;
  }
}

export function approvedBy(i, item, cb) {
  if (!item.approved_by) return;
  return (
    <a
      href={`/visit/${item.id}`}
      onClick={() => {
        if (cb) cb(item.id);
      }}>
      <span className="approved-by">
        <img className="w-32 img-circle avatar-crop" src={item.approved_by.photo ? item.approved_by.photo : Avatar} /> {item.approved_by.first_name}
        {item.approved_by.last_name}
      </span>
    </a>
  );
}

export function dateStart(i, item) {
  if (!item.start) return;
  let date = new Date(item.start);
  return moment(date).format("DD/MM/yyyy");
}

export function dateEnd(i, item) {
  if (!item.end) return;
  let date = new Date(item.end);
  return moment(date).format("DD/MM/yyyy");
}

export function dateCreated(i, item) {
  if (!item.end) return;
  let date = new Date(item.created);
  return moment(date).format("DD/MM/yyyy");
}

export function dateTimeCreated(item) {
  if (!item || !item.created) return "—";
  // Humanized, unambiguous format, e.g. "20 Jul 2026, 14:30".
  return moment(new Date(item.created)).format("DD MMM YYYY, HH:mm");
}

// REVIEW
export function reviewTaskSalePriceMonitoring(i, item) {
  if (item.additional_info?.sale_price && item.additional_info.sale_price !== "None") {
    let sale_price = item.additional_info.sale_price;

    return <p>{sale_price}</p>;
  }
}
export function reviewTaskPriceMonitoring(i, item) {
  if (item.additional_info?.price && item.additional_info.price !== "None") {
    let price = item.additional_info.price;

    return <p>{price}</p>;
  }
}

export function reviewMerchandiserNamePhone(i, item) {
  if (item?.visit?.user) {
    let user = item.visit.user;

    return (
      <span className="tbl-user-cell">
        {user.photo ? (
          <img
            className="tbl-user-avatar"
            src={user.photo}
            onError={e => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}
        <span className="tbl-user-avatar-fallback" style={user.photo ? { display: "none" } : {}}>
          <span className="material-symbols-outlined">person</span>
        </span>
        <span className="tbl-user-name">
          {user.first_name} {user.last_name} {user.phone && <span>, {user.phone}</span>}
        </span>
      </span>
    );
  }
}

export function getApproveRejectInfo(type, item) {
  if (!item.approved_by) return;

  if (type === "name") {
    return (
      <span>
        <span>
          {item.approved_by.first_name} {item.approved_by.last_name}
        </span>
      </span>
    );
  }
}

export function reviewTaskSupervisor(i, item) {
  if (item.visit && item.visit.point && item.visit.point.responsible_supervisors) {
    let user = item.visit.point.responsible_supervisors[0];

    return (
      <span className="tbl-user-cell">
        {user?.photo ? (
          <img
            className="tbl-user-avatar"
            src={user.photo}
            onError={e => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}
        <span className="tbl-user-avatar-fallback" style={user?.photo ? { display: "none" } : {}}>
          <span className="material-symbols-outlined">person</span>
        </span>
        <span className="tbl-user-name">
          {user?.first_name} {user?.last_name}
          {(user?.phone || user?.phone_number) && <span>, {user?.phone || user?.phone_number}</span>}
        </span>
      </span>
    );
  }
}

export function reviewCreatedByTaskSupervisor(item) {
  if (item?.task && item?.task.created_by) {
    let user = item?.task.created_by;

    return (
      <span>
        <img className="w-32 img-circle avatar-crop" src={user?.photo ? user?.photo : Avatar} />
        <span>
          {user?.first_name} {user?.last_name}
        </span>
        {(user?.phone || user?.phone_number) && <span> ,{user?.phone || user?.phone_number}</span>}
      </span>
    );
  }
}

export function reviewTaskNework(i, item) {
  item.network = item.task?.network;

  return (
    item.network && (
      <span>
        <img className="w-32 img-circle avatar-crop" src={item.network.image ? item.network.image : AvatarCompany} /> {item.network.name}
      </span>
    )
  );
}
export function reviewTaskVisitPoint(i, item) {
  if (item?.visit?.point) {
    let point = item.visit.point;

    return (
      <Link to={"/point/" + point.id} target="_blank">
        {point.name}
      </Link>
    );
  }
  return null;
}

export function reviewTaskPoint(i, item) {
  if (item?.task?.point) {
    let point = item.task.point;

    return (
      <Link to={"/point/" + point.id} target="_blank">
        {point.name}
      </Link>
    );
  }
  return null;
}

export function reviewTaskPointName(i, item) {
  if (item?.task?.point) {
    let point = item.task.point;

    return <span className="answers-row-item-link">{point.name}</span>;
  }
  return null;
}

export function taskPoint(item) {
  if (item.point) {
    let point = item.point;
    return (
      <Link to={"/point/" + point.id} target="_blank">
        {point.name}
      </Link>
    );
  }
}

export function getTaskNetwork(item) {
  if (item.point) {
    let point = item.point;
    return (
      <Link to={"/point/" + point.id} target="_blank">
        {point.name}
      </Link>
    );
  }
}

export function reviewTaskPriority(i, item) {
  return <div>{PRIORITY[item.task?.priority] ? PRIORITY[item.task.priority] : ""}</div>;
}

export function dateFormat(date) {
  if (!date) return;
  date = new Date(date);
  return moment(date).format("DD/MM/yyyy HH:mm");
}

export function dateFormat2(date) {
  date = new Date(date);
  return moment(date).format("yyyy-MM-DD");
}

export function dateFormatFullZero(date) {
  date = new Date(date);
  return moment(date).format("yyyy-MM-DDTHH:mm:ss");
}

export function dateFormatFull(date) {
  date = new Date(date);
  return moment(date).format("yyyy-MM-DDT23:59:59");
}
